const locales: { [id: number]: string } = {
  1: 'en-GB',
};

export default locales;
